import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
//import {store} from './store/store';
import  ThemeContext  from "./context/ThemeContext"; 
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './core/store';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { NotificationProvider } from "./context/NotificationContext"; // Import du contexte
import './jsx/components/landing/i18n/i18n';

const store = configureStore({ reducer: rootReducer, devTools: true });
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store = {store}>
      <BrowserRouter basename='/'>

        <ThemeContext>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
